import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './ActivityPlayButtonOverlay.module.scss';
import playButton from 'assets/svg/play-button.svg';
import { t } from '../../translations';

const ActivityPlayButtonOverlay = ({ onOverlayClick }) => {
  const playButtonRef = useRef();

  const onClick = () => onOverlayClick();
  const onKeyDown = e => {
    if (e.key === 'Enter' || e.keyCode == 32) {
      playButtonRef?.current?.click();
    }
  };
  const onTouchEnd = () => onOverlayClick();

  return (
    <div className={styles.overlay}>
      <div
        className={styles.playButtonContainer}
        onClick={onClick}
        onTouchEnd={onTouchEnd}
        tabIndex={-1}
      >
        <div
          aria-label={t('Play')}
          className={styles.playButton}
          onClick={onClick}
          onKeyDown={onKeyDown}
          role="button"
          tabIndex={0}
          ref={playButtonRef}
        >
          <img alt={t('Play')} src={playButton} />
        </div>
      </div>
    </div>
  );
};

ActivityPlayButtonOverlay.propTypes = {
  onOverlayClick: PropTypes.func
};

export default ActivityPlayButtonOverlay;
